var exports = {
  "m": "xe564cbfb--fa39d8--avatar",
  "U": "xe564cbfb--fa39d8--name",
};

module.exports = exports;
